var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDestinationBrandlive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_558)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 71.1111,
    fill: "url(#paint0_linear_25_558)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512 0H0V512H512V0ZM88.8889 49.7778C65.3248 49.7778 46.2222 68.8804 46.2222 92.4445V423.111C46.2222 446.675 65.3248 465.778 88.8889 465.778H419.556C443.12 465.778 462.222 446.675 462.222 423.111V92.4445C462.222 68.8804 443.12 49.7778 419.556 49.7778H88.8889Z",
    fill: "url(#paint1_linear_25_558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.653 213.026C192.364 213.026 200.134 216.499 205.199 221.924C212.865 210.262 217.836 191.62 217.836 170.62C217.836 159.864 216.523 149.736 214.224 140.838L193.502 153.162L204.235 117.933C199.182 110.837 193.061 106.678 186.475 106.678C169.157 106.678 155.114 135.31 155.114 170.631C155.114 189.785 159.249 206.963 165.789 218.683C170.609 215.164 176.835 213.038 183.653 213.038V213.026Z",
    fill: "#A6FF79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.386 213.015C329.097 213.015 336.868 216.488 341.932 221.912C349.598 210.25 354.569 191.62 354.569 170.608C354.569 159.852 353.257 149.724 350.957 140.827L330.235 153.15L340.968 117.922C335.915 110.825 329.806 106.667 323.208 106.667C305.89 106.667 291.847 135.298 291.847 170.608C291.847 189.761 295.982 206.928 302.522 218.648C307.342 215.129 313.568 213.003 320.386 213.003V213.015Z",
    fill: "#A6FF79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.07 293.111C392.794 289.185 386.952 288.65 383.003 291.891C382.875 291.995 370.505 302.008 360.504 296.642C348.181 290.033 351.654 270.589 351.712 270.287C352.687 265.269 349.412 260.402 344.394 259.403C339.365 258.393 334.475 261.68 333.476 266.709C333.232 267.929 328.354 293.889 345.335 308.617C342.989 315.679 337.936 328.211 328.574 340.791C309.92 365.856 283.833 378.563 251.055 378.563C218.277 378.563 193.061 363.068 174.5 332.521C164.685 316.364 159.47 299.963 157.112 291.055C170.783 282.123 173.245 264.212 172.235 253.712C171.747 248.625 167.217 244.908 162.141 245.372C157.042 245.837 153.291 250.355 153.732 255.443C153.744 255.629 155.161 273.527 143.685 276.989C133.162 280.171 124.741 271.251 124.311 270.775C120.896 266.988 115.054 266.663 111.232 270.055C107.399 273.469 107.051 279.335 110.454 283.168C111.011 283.795 122.336 296.281 139.027 296.281C139.097 296.281 139.178 296.281 139.248 296.281C141.943 306.421 147.646 323.984 158.297 341.662C180.156 377.959 212.226 397.147 251.043 397.147C299.595 397.147 328.11 372.535 343.477 351.883C353.442 338.491 359.215 325.133 362.27 316.48C363.838 316.701 365.383 316.817 366.893 316.817C381.981 316.817 394.246 306.689 394.92 306.131C398.834 302.844 399.334 297.025 396.07 293.099V293.111Z",
    fill: "#A6FF79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_558",
    x1: 28.4445,
    y1: 16,
    x2: 256,
    y2: 272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080D06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_558",
    x1: 256,
    y1: 512,
    x2: 256,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6AE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 71.1111,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDestinationBrandlive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/destination-brandlive.826cdbaa51e40e794849450593aa2424.svg";